import { createContext } from 'react';
import type { ChatMessagesContextValue } from '../../../types/chatMessagesContext';

export const ChatMessagesContext =
  createContext<ChatMessagesContextValue | null>(null);
